module.exports = __webpack_public_path__ + "static/media/4-日常记录.9e21935f.png";